import ActionType from "./actionsPermissionsActionTypes";

const fetchPending = () => ({
  type: ActionType.FETCH_PENDING,
});

const fetchSuccess = (data) => ({
  type: ActionType.FETCH_SUCCESS,
  data: data,
});

const fetchError = (message) => ({
  type: ActionType.FETCH_ERROR,
  data: message,
});

const fetchAllPending = () => ({
  type: ActionType.FETCH_ALL_PENDING,
});

const fetchAllSuccess = (data) => ({
  type: ActionType.FETCH_ALL_SUCCESS,
  data,
});

const fetchAllError = (message) => ({
  type: ActionType.FETCH_ALL_ERROR,
  message,
});

const editPending = () => ({
  type: ActionType.EDIT_PENDING,
});

const editDone = () => ({
  type: ActionType.EDIT_DONE,
});

const setFilter = (data) => ({
  type: ActionType.SET_FILTER,
  data,
});

export default {
  fetchPending,
  fetchSuccess,
  fetchError,
  fetchAllPending,
  fetchAllSuccess,
  fetchAllError,
  editPending,
  editDone,
  setFilter,
};
